import { Button } from '@krp/ui-kit'

import { QueryState } from './QueryState'
import type { HeldVm } from '../port/types'
import { RmkDialog } from './RmkDialog'

/**
 * Отложенные чеки кассы — как в старом РМК: выбирают по времени и составу
 * (номера у отложенного чека нет, он ещё не документ). «Открыть» ставит его на
 * место текущего, а текущий с позициями откладывается — об этом скажет
 * сообщение. Хранятся на сервере (UI-RMK): видны с другого компьютера за той же
 * кассой и переживают F5. «Удалить» — без подтверждения, но с временем в
 * подписи: денег по отложенному чеку нет.
 */
export function HeldCartsDialog({
  held,
  busy,
  onRestore,
  onDrop,
  onRetry,
  onClose,
}: {
  held: HeldVm
  busy: boolean
  onRestore: (id: string) => void
  onDrop: (id: string) => void
  onRetry: () => void
  onClose: () => void
}) {
  return (
    <RmkDialog title="Отложенные чеки" size="md" onClose={onClose}>
      <QueryState
        requestIdHidden
        query={held.query}
        what="Отложенные чеки"
        emptyText="Отложенных чеков нет — отложите чек, если покупатель пока не может заплатить"
        onRetry={onRetry}
      />
      {held.carts.length > 0 && (
        <ul className="rmk-held" aria-label="Отложенные чеки">
          {held.carts.map((cart) => (
            <li key={cart.id} className="rmk-held__item">
              <div className="rmk-held__about">
                <span>
                  <b>{cart.timeText}</b> · {cart.linesText}, {cart.totalText}
                </span>
                <span className="rmk-held__preview">{cart.preview}</span>
                {cart.contact !== null && <span className="rmk-held__preview">Чек покупателю: {cart.contact}</span>}
              </div>
              <div className="rmk-held__actions">
                <Button variant="primary" disabled={busy} aria-label={`Открыть отложенный чек ${cart.timeText}`} onClick={() => onRestore(cart.id)}>
                  Открыть
                </Button>
                <Button variant="ghost" disabled={busy} aria-label={`Удалить отложенный чек ${cart.timeText}`} onClick={() => onDrop(cart.id)}>
                  Удалить
                </Button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </RmkDialog>
  )
}
